export default __webpack_public_path__ + "static/media/jiesan.049248dc.png";